import { useBooleanFlagValue } from '@openfeature/react-sdk';

import { usePermissions } from '@/entities/user';

/**
 * Who may open Reels Creator's settings and admin tools: an instance admin, or anyone the
 * reels_admin flag is on for. reels-api applies the same rule to the routes behind them.
 */
export const useIsReelsAdmin = (): boolean => {
  const { isInstanceAdmin } = usePermissions();
  const isFlagged = useBooleanFlagValue('reels_admin', false);
  return isInstanceAdmin || isFlagged;
};
